module.exports = __webpack_public_path__ + "img/restaurant.467b4db9.jpg";